// extracted by mini-css-extract-plugin
export default {"container":"UF-z","contactUsLink":"VF-z"};